import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inviteDialog"]
  static values = { openInviteOnConnect: { type: Boolean, default: false } }

  connect() {
    if (this.openInviteOnConnectValue) {
      this.openInvite()
    }
  }

  openInvite() {
    if (this.hasInviteDialogTarget) {
      this.inviteDialogTarget.showModal()
    }
  }
}
